/**
 * @file mix-in設定：clip-pathを用いた非表示スタイル
 */

export const clipPathHidden = `
    clip-path: polygon(1px 1px, 1px 1px, 1px 1px, 1px 1px);
    position: absolute;
    width: 1px;
    height: 1px;
`;
